import { joinClassNames } from "@utils/helpers";
import { Text } from "@components/theming";

export default function EventDescription({
  description = "",
  appearance,
}: {
  description: string;
  appearance?: string;
}) {
  return (
    <Text
      data-testid="eventdescription"
      as="div"
      whitelabelClasses={joinClassNames(
        "prose mt-4 max-w-none",
        appearance === "dark" ? "prose-invert" : ""
      )}
      shopsiteClasses="text-black prose max-w-full text-sm prose-table:border-collapse prose-tr:border-none prose-img:inline prose-img:align-middle mt-6"
      dangerouslySetInnerHTML={{ __html: description }}
    />
  );
}
